import _ from 'lodash'
import { i18n } from '@/common/utils/i18n'
import VueI8n from '@/i18n/locale'
import { contentMap } from '@/config/visit/addvisit/config-visit-content.js'
import { getVisitList } from '@/api/visit/index.js'
import {
  BIZOPP_STATUS_MAP,
  VISIT_WAY_MAP,
  VISIT_CONTENT_MAP
} from '@/config/visit/addvisit/config.js'

import parser from '@/common/utils/ruleParser'
import parserBR from '@/common/utils/ruleParser-BR'
import parserJP from '@/common/utils/ruleParser-JP'
import parserCR from '@/common/utils/ruleParser-CR'
import parserCO from '@/common/utils/ruleParser-CO'
import parserDO from '@/common/utils/ruleParser-DO'
import parserCL from '@/common/utils/ruleParser-CL'
import parserPE from '@/common/utils/ruleParser-PE'

let parserFn = {
  MX: parser,
  BR: parserBR,
  JP: parserJP,
  CR: parserCR,
  CO: parserCO,
  DO: parserDO,
  CL: parserCL,
  PE: parserPE
}
// 对于不同国家 走不同的 rules 配置
export function configParser (config = [], country) {
  // 调用通用的rule parser方法，转换为rich-ui 格式的rule
  return _.chain(config)
    .reduce(
      (red, { rules, ...others }) =>
        rules
          ? red.concat({
            ...others,
            ...(parserFn[country] || parserFn['MX'])(rules)
          })
          : red.concat({ ...others }),
      []
    )
    .value()
}

// 拜访日期格式
export function parseVisitTime (timeStr) {
  let arr = timeStr.split('-')
  return `${arr[0]}-${arr[1]}-${arr[2]} ${arr[3]}:${arr[4]}`
}

// 属性赋值
export function attrAssign (data, obj) {
  return key => {
    data[key] && (obj[key] = data[key])
  }
}

// 根据 国家、商机状态、拜访方式、拜访内容 获得showStatus='MX_follow_online_phoneTalk'

export function getShowSatus (country, status, way, content) {
  return `${country}_${BIZOPP_STATUS_MAP[status] || ' '}_${VISIT_WAY_MAP[way]
    || ' '}_${VISIT_CONTENT_MAP[content] || ' '}`
}

// 拜访记录按钮 弹窗相关
let submitToast = null
let oneDay = 24 * 60 * 60 * 1000
let visitSelList = [
  {
    content: VueI8n.t('FoodOpB_1_New_visits_HXsz' /** 新建拜访 */),
    value: 1,
    path: '/v2/add-visit',
    request (shopId) {
      // 拜访列表  筛选
      let params = {
        shopId: shopId,
        visitStatus: 1, // 1：计划中，2：已过期，3：已完成，4：已关闭
        startTime: getTimeString(new Date().getTime(), 'visitTimeShow'), // 三日内
        endTime: getTimeString(
          getDayStartTime(new Date()) + oneDay * 3 - 60 * 1000,
          'visitTimeShow'
        ),
        pageNo: 1,
        pageSize: 5
      }
      return getVisitList(params)
    }
  },
  {
    content: VueI8n.t('FoodOpB_1_New_Visiting_tIni' /** 新建拜访计划 */),
    value: 2,
    path: '/v2/add-visit-plan'
  },
  {
    content: i18n.gettext('查看拜访记录'),
    value: 3,
    path: '/my-visit'
  }
]
export function showVisitSel (shopId) {
  this.$createActionSheet({
    title: i18n.gettext('请选择'),
    data: visitSelList,
    onSelect: item => {
      if (item.request) {
        showLoading.call(this, true)
        item.request(shopId).then(res => {
          showLoading.call(this, false)
          if (res && res.list && res.list.length) {
            showVisitPlanSel.call(this, res.list)
          } else {
            this.$router.push({ path: item.path, query: { shopId: shopId } })
          }
        })
      } else {
        showLoading.call(this, false)
        this.$router.push({ path: item.path, query: { shopId: shopId } })
      }
    }
  }).show()
}
export function showVisitPlanSel (list) {
  let data = list.map(item => {
    return {
      content: item.visitTime + ' ' + (contentMap[item.visitTemplate] || ''),
      path: `/v2/add-visit?shopId=${item.shopId}&visitId=${item.visitId}&edit=true`
    }
  })
  data.push({
    content: VueI8n.t('FoodOpB_1_New_visits_HXsz' /** 新建拜访 */),
    path: `/v2/add-visit?shopId=${list[0].shopId}`
  })
  this.$createActionSheet({
    title: VueI8n.t(
      'FoodOpB_1_A_recent_LtIi' /** 已有近期未完成的拜访计划，是否继续录入? */
    ),
    data: data,
    onSelect: item => {
      this.$router.push({ path: item.path })
    }
  }).show()
}

export function showLoading (ok) {
  if (ok) {
    submitToast = this.$createToast({
      type: 'loading',
      time: 0,
      mask: true
    })
    submitToast.show()
  } else {
    submitToast && submitToast.hide()
  }
}

export function getTimeString (timeStamp, type) {
  let date = new Date(timeStamp)
  let y = date.getFullYear()
  let m = addZero(date.getMonth() + 1)
  let d = addZero(date.getDate())
  let h = addZero(date.getHours())
  let mi = addZero(date.getMinutes())
  let timeData = {
    visitTimeShow: `${y}-${m}-${d} ${h}:${mi}`,
    visitTimeModal: `${y}-${m}-${d}-${h}-${mi}`
  }
  return timeData[type] || timeData
}

function addZero (n) {
  return n > 9 ? n : '0' + n
}

export function getDayStartTime (today) {
  today.setHours(0, 0, 0, 0)
  return today.getTime()
}

export function getMapKey (map) {
  if (!map) return {}
  const mapKey = {}
  for (let key in map) {
    mapKey[map[key]] = key
  }
  return mapKey
}
